import { render, staticRenderFns } from "./OfficialHolidaysPlanDetailsTable.vue?vue&type=template&id=ae3fccd8&"
import script from "./OfficialHolidaysPlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports